function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React from 'react';
import T from 'prop-types';
import cn from 'classnames';
var FormSection = function(props) {
    var children = props.children, title = props.title, className = props.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn('FormSection', _define_property({}, className, className))
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "title"
    }, title), children);
};
FormSection.propTypes = {
    children: T.node,
    title: T.string,
    className: T.string
};
export default FormSection;
